import React, { useState, useEffect, useContext } from 'react';
import AuthLayout from '../Layouts/authLayout';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
// import Button from '@mui/material/Button';
// import Checkbox from '@mui/material/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import { userLogin } from '../../actions/userActions';
import { toast } from 'react-toastify';
import './styles.css';
import LoadingView from '../Loader/LoadingView';
import { PayloadContext } from '../../context';
import { PORTAL } from '../../config';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';

const styles = {
	'btnColor' : {
		backgroundColor
		: '#0F9710',
		color
		: 'white',
		fontWeight
		: 'bold'
	},
	'btnColorProd' : {
		backgroundColor
		: '#b1e3fa',
		color
		: 'black',
		fontWeight
		: 'bold'
	},
	'fullWidth' : {
		width
		: '100%'
	}
};

const LoginPage = ({ classes }) =>
{
	const [ loading, setLoading ] = useState(false);

	const [ email, setEmail ] = useState('');

	const [ psw, setPsw ] = useState('');

	const [ remember, setRemenber ] = useState(localStorage.getItem('remember'));

	const [ showPassword, setShowPassword ] = useState(false);

	const { getPayload } = useContext(PayloadContext);

	useEffect(() =>
	{
		if (localStorage.getItem('remember'))
		{
			setEmail(localStorage.getItem('email'));
			setPsw(localStorage.getItem('psw'));
		}
	}, []);

	const handleRemember = (e) =>
	{
		const check = e.target.checked;

		localStorage.setItem('remember', check);
		setRemenber(check);
	};

	const handleSubmit = (event) =>
	{
		event.preventDefault();
		const data = new FormData(event.currentTarget);

		const obj = {
			email : data.get('username'),

			password : data.get('password')
		};

		if (obj.email && obj.email.trim() !== '' && obj.password && obj.password.trim() !== '')
		{
			if (!loading)
			{
				if (localStorage.getItem('remember'))
				{
					localStorage.setItem('email', obj.email);
					localStorage.setItem('psw', obj.password);
				}
				setLoading(true);
				userLogin(obj).then((res) =>
				{
					if (res?.data?.success)
					{
						// eslint-disable-next-line no-console
						// console.log('enter 2 ===== ', res.data);
						localStorage.setItem('userAuthToken', res.data.token);
						// history.push('/dashboard');
						getPayload();
					}
					else
					{
						toast.error('Invalid cradentials, Please try again');
						setLoading(false);
					}
				})
					.catch((err) =>
					{
						// login fail
						// eslint-disable-next-line no-console
						console.log('err ===== ', err);
						toast.error('Invalid cradentials, Please try again');
						setLoading(false);
					});
			}
		}
		else
		{
			toast.error('Please ener the User Name and Password');
		}
	};

	return (
		<Container component='main' maxWidth='xs'>
			<CssBaseline />
			<Box
				sx={{
					display
					: 'flex',
					flexDirection
					: 'column',
					alignItems : 'center'
				}}
			>
				{loading && <LoadingView />}
				<span className={`subHeadingSM ${PORTAL=='WORLD'?'whiteTxt':''}`}><b>Please sign in</b></span>
				<Box component='form' className='w-100' onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
					<div>
						<TextField
							variant='outlined'
							required
							fullWidth
							id='username'
							placeholder='Username'
							name='username'
							autoFocus
							className='inputField'
							InputLabelProps={{
								style : { color: '#fff' }
							}}
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>
					</div>
					<div className='position-relative'>
						<TextField
							variant='outlined'
							required
							fullWidth
							placeholder='Password'
							name='password'
							margin='normal'
							type={showPassword?'text':'password'}
							id='password'
							className='inputField'
							InputLabelProps={{
								style : { color: '#fff' }
							}}
							value={psw}
							onChange={(e) => setPsw(e.target.value)}
						/>
						<span className='password-eye-icon' onClick={() => setShowPassword(!showPassword)}>
							{showPassword?<VisibilityOffOutlinedIcon className='whiteTxt'/>:<VisibilityOutlinedIcon className='whiteTxt'/>}
						</span>
					</div>
					<div className='flexAutoCol mrgnTSM'>
						<Button
							type='submit'
							fullWidth
							variant='contained'
							className={PORTAL=='WORLD'?classes.btnColorProd:classes.btnColor}
						>
							<div className='flexAutoCol pdngHXS'>
								<img src={PORTAL=='WORLD'?'/images/loginIcon-prod.png':'/images/loginIcon.png'} alt='' className='iconBox' />
							</div>
							Sign In
						</Button>
					</div>
					<div className='flexRow alignCntr pdngVSM'>
						<div className='flexAutoRow alignCntr '>
							<Checkbox className='cb' color='success' onChange={handleRemember} checked={remember} />
							<small className={`${PORTAL=='WORLD'?'whiteTxt':''}`}><b>Remember Me</b></small>
						</div>
						<div className='flexInline alignCntr hrLineSM mrgnHSM' />
						<div className='flexAutoRow alignCntr'>
							<span>
								<Link to='/forgot-password' className='txtDecorationNone' >
									<small className={PORTAL=='WORLD'?'whiteTxt':'txtColorBlackL'}><b>Forgot Password ?</b></small>
								</Link>
							</span>
						</div>
					</div>
				</Box>
			</Box>
		</Container>
	);
};

export default AuthLayout(withStyles(styles)(LoginPage));
